// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"092f8515","703":"efb345fc"}[chunkId] + ".chunk.js";
};